import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";

const BatchTransferResultModal = ({ isOpen, toggle, failed = [], updated = 0 }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Batch Transfer Result</ModalHeader>
      <ModalBody>
        <div>
          <strong>Successfully updated:</strong> {updated}
        </div>
        {failed && failed.length > 0 && (
          <div className="mt-3">
            <strong>Failed ({failed.length}):</strong>
            <Table bordered size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {failed.map((item, idx) => (
                  <tr key={item.id || idx}>
                    <td>{item.id}</td>
                    <td>{item.reason}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        {(!failed || failed.length === 0) && (
          <div className="mt-3 text-success">All selected enquiries were transferred successfully.</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BatchTransferResultModal;
